import Table from 'react-bootstrap/Table';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { FaPencil } from "react-icons/fa6";
import MyComponent from './myComponent';
import './instruction.css'; // Main branch wali CSS file

// Functional component definition
function Instruction() {

  // Inline styles for the table
  const tableStyle = {
    fontSize: '0.9rem',
    width: '100%',
    margin: '0 auto',
    borderCollapse: 'collapse'
  };

  // State to control form visibility
  const [, setIsFormVisible] = useState(false);

  // Handler for save button click
  const handleSaveClick = () => {
    setIsFormVisible(false);
    alert('Provider details saved successfully!');
  };

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden'
      }}
    >

      {/* Heading */}
      <h3
        className="instruction-heading"
        style={{
          backgroundColor: "white",
          color: "#004aad",
          padding: "5px",
          marginBottom: "5px"
        }}
      >
        Instructions
      </h3>


      {/* Data table */}
      <Table
        striped
        bordered
        hover
        className="instruction-table"
        style={tableStyle}
      >
        <tbody>

          <tr>
            <th
              className="instruction-table-header"
              style={{
                fontSize: '0.9rem',
                borderTop: "3px solid #004aad",
                padding: "5px",
                width: "100%"
              }}
            >

              {/* Search bar */}
              <div
                className="instruction-search-row"
                style={{
                  display: "flex",
                  alignItems: "center"
                }}
              >

                <span
                  className="instruction-search-label"
                  style={{
                    marginRight: '10px',
                    fontWeight: 'normal'
                  }}
                >
                  Search:
                </span>

                <input
                  type="text"
                  placeholder=""
                  className="instruction-search-input"
                  style={{
                    padding: '5px',
                    borderRadius: '4px',
                    height: "35px"
                  }}
                />

                <MyComponent />

              </div>


              {/* Info */}
              <div
                className="instruction-entry-info"
                style={{
                  marginTop: "5px",
                  fontSize: "15px",
                  fontWeight: "normal"
                }}
              >
                Showing 0 to 0 of 0 entries
              </div>

              <br />


              {/* Column headings */}
              <div
                className="instruction-column-header"
                style={{
                  marginTop: "5px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  width: "100%"
                }}
              >

                <span style={{ marginRight: "120px" }}>
                  Active
                </span>

                <span style={{ marginRight: "120px" }}>
                  Function
                </span>

                <span style={{ marginRight: "120px" }}>
                  Where
                </span>

                <span>
                  Conditions
                </span>

              </div>

            </th>
          </tr>


          {/* Message row */}
          <tr>
            <th
              className="instruction-no-data"
              style={{
                textAlign: "center",
                fontSize: "16px"
              }}
            >
              No data available in table
            </th>
          </tr>


          {/* Footer */}
          <tr>
            <th
              className="instruction-footer"
              style={{
                borderTop: "3px solid #004aad",
                backgroundColor: "#f4f4f4",
                padding: "15px",
                fontSize: "14px",
                fontWeight: "normal"
              }}
            >
              Showing 0 to 0 of 0 entries
            </th>
          </tr>

        </tbody>
      </Table>


      {/* Save button */}
      <Button
        className="instruction-save-button"
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginLeft: '5px',
          marginTop: "50px"
        }}
        onClick={handleSaveClick}
      >
        <FaPencil className="instruction-save-icon" />
        Save
      </Button>

    </div>
  );
}

export default Instruction;